import Facebook from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TelegramIcon from "@mui/icons-material/Telegram";
import InstagramIcon from "@mui/icons-material/Instagram";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import { Box, List, ListItem, ListItemButton, ListItemIcon, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { colors, radii } from "../../theme/designTokens";

export default function SocialMediaPages() {
  // Store
  const { webSettings } = useSelector((state) => state.webSettings);

  //! Translate
  // Store
  const { langArrFromClientSideFrontend } = useSelector(
    (state) => state.miscFront
  );
  const translateFront = (String) => {
    let translation = "";
    if (
      langArrFromClientSideFrontend &&
      langArrFromClientSideFrontend.length > 0
    ) {
      const T = langArrFromClientSideFrontend.find((l) => l.title === String);
      if (T && T.value) {
        let obj = { ...T };
        if (T.value === "") obj.value = T.title;
        translation = T.value;
      }
    }
    return translation;
  };
  //! Translate

  const hasSocialLinks =
    (webSettings.socialMediaPages &&
      (webSettings.socialMediaPages.fb ||
        webSettings.socialMediaPages.twitter ||
        webSettings.socialMediaPages.linkedIn ||
        webSettings.socialMediaPages.telegram ||
        webSettings.socialMediaPages.instagram)) ||
    (webSettings.additionalSocialPages &&
      webSettings.additionalSocialPages.length > 0);

  if (!hasSocialLinks) return null;

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, mb: 1.5 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: radii.md,
            bgcolor: colors.primaryLight,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <ShareOutlinedIcon sx={{ fontSize: 16, color: colors.primary }} />
        </Box>
        <Typography sx={{ fontWeight: 700, fontSize: 15, color: colors.ink }}>
          Social Media Pages
        </Typography>
      </Box>
      <List
        dense
        sx={{
          "& .MuiListItemButton-root": {
            borderRadius: radii.md,
            "&:hover": { bgcolor: colors.primaryLight },
          },
          "& .MuiTypography-root": {
            color: colors.ink2,
          },
        }}
      >
        {webSettings.socialMediaPages &&
          webSettings.socialMediaPages.fb !== "" && (
            <ListItem disablePadding>
              <ListItemButton
                onClick={() =>
                  window.open(webSettings.socialMediaPages.fb, "_blank")
                }
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <Facebook sx={{ color: "#4F7CFF", fontSize: 20 }} />
                </ListItemIcon>
                <Typography variant="body2">
                  {translateFront("Facebook")}
                </Typography>
              </ListItemButton>
            </ListItem>
          )}
        {webSettings.socialMediaPages &&
          webSettings.socialMediaPages.twitter !== "" && (
            <ListItem disablePadding>
              <ListItemButton
                onClick={() =>
                  window.open(webSettings.socialMediaPages.twitter, "_blank")
                }
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <TwitterIcon sx={{ color: "#4F9DE0", fontSize: 20 }} />
                </ListItemIcon>
                <Typography variant="body2">
                  {translateFront("Twitter")}
                </Typography>
              </ListItemButton>
            </ListItem>
          )}
        {webSettings.socialMediaPages &&
          webSettings.socialMediaPages.linkedIn !== "" && (
            <ListItem disablePadding>
              <ListItemButton
                onClick={() =>
                  window.open(webSettings.socialMediaPages.linkedIn, "_blank")
                }
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <LinkedInIcon sx={{ color: "#4F9DE0", fontSize: 20 }} />
                </ListItemIcon>
                <Typography variant="body2">
                  {translateFront("LinkedIn")}
                </Typography>
              </ListItemButton>
            </ListItem>
          )}
        {webSettings.socialMediaPages &&
          webSettings.socialMediaPages.telegram !== "" && (
            <ListItem disablePadding>
              <ListItemButton
                onClick={() =>
                  window.open(webSettings.socialMediaPages.telegram, "_blank")
                }
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <TelegramIcon sx={{ color: "#4F9DE0", fontSize: 20 }} />
                </ListItemIcon>
                <Typography variant="body2">
                  {translateFront("Telegram")}
                </Typography>
              </ListItemButton>
            </ListItem>
          )}
        {webSettings.socialMediaPages &&
          webSettings.socialMediaPages.instagram !== "" && (
            <ListItem disablePadding>
              <ListItemButton
                onClick={() =>
                  window.open(webSettings.socialMediaPages.instagram, "_blank")
                }
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <InstagramIcon sx={{ color: "#E1739C", fontSize: 20 }} />
                </ListItemIcon>
                <Typography variant="body2">
                  {translateFront("Instagram")}
                </Typography>
              </ListItemButton>
            </ListItem>
          )}

        {webSettings.additionalSocialPages &&
          webSettings.additionalSocialPages.length > 0 &&
          webSettings.additionalSocialPages.map((x, i) => (
            <ListItem disablePadding key={i}>
              <ListItemButton onClick={() => window.open(x.pageLink, "_blank")}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <img
                    src={x.iconUrl}
                    alt={x.pageName}
                    style={{ height: "1.25rem" }}
                  />
                </ListItemIcon>
                <Typography variant="body2">{x.pageName}</Typography>
              </ListItemButton>
            </ListItem>
          ))}
      </List>
    </>
  );
}
